import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { Input, ImageInput } from 'containers/form';
import Hint from 'components/hint';
import Button, { btnThemes } from 'components/button';
import { StaticPaginator } from 'components/paginator';
import Modal, { Header, Content, Footer } from 'components/modal';

import smiles from './assets/smiles/smiles';

import translates from './editor-light-i18n.json';

const classesModalEditor = new Bem('modalEditor');
const classesSmile = new Bem('btnSmile');
const classesModalSmile = new Bem('modalSmile');
const classesModalPhoto = new Bem('modalPhoto');
const modalContentCfg = {
  a: 'a',
  img: 'img',
  iframe: 'iframe',
  smiles: 'smiles'
};

@I18nHoc(translates)
export default class ModalEditor extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onCloseRequired: PropTypes.func,
    insertSrc: PropTypes.func,
    content: PropTypes.string
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.onSmileClick = this.onSmileClick.bind(this);
    this.renderSmiles = this.renderSmiles.bind(this);
    this.state = {
      inputValue: null,
      imageValue: []
    };
  }

  onSmileClick(smilePath) {
    const imageValue = [...this.state.imageValue];
    const index = imageValue.indexOf(smilePath);
    if (index < 0) {
      imageValue.push(smilePath);
    } else {
      imageValue.splice(index, 1);
    }
    this.setState({ imageValue });
  }

  renderSmiles(it, index) {
    return (
      <Button
        key={index}
        {...classesSmile(
          null,
          { active: this.state.imageValue.indexOf(it) >= 0 }
        )}
        onClick={() => this.onSmileClick(it)}
        iconOnly
        customRenderer
      >
        <span {...classesSmile('content')}>
          <img {...classesSmile('icon')} src={it} alt="smile" />
        </span>
      </Button>
    );
  }

  renderContent() {
    const { i18n } = this;
    const { content } = this.props;

    if (content === modalContentCfg.smiles) {
      return (
        <StaticPaginator
          {...classesModalSmile('content')}
          data={smiles}
          limitPerPage={50}
          renderItem={this.renderSmiles}
        />
      );
    }
    if (content === modalContentCfg.img) {
      const imageUploaded = !!this.state.imageValue.length;
      return (
        <div {...classesModalPhoto('content')}>
          <Input
            {...classesModalPhoto('input')}
            value={this.state.inputValue}
            schema={{
              placeholder: i18n('addImgPlaceholder'),
              readOnly: imageUploaded
            }}
            onChange={(inputValue) => {
              if (!imageUploaded) this.setState({ inputValue });
            }}
            noError
          />
          <div {...classesModalPhoto('text')} children={i18n('addImgOrText')} />
          <Hint {...classesModalPhoto('hint')} text={i18n('addImgText')} />
          <ImageInput
            {...classesModalPhoto('img')}
            value={this.state.imageValue}
            imageSize="small"
            circled
            schema={{ isArray: true }}
            onChange={imageValue => this.setState({ imageValue })}
          />
          <div {...classesModalPhoto('text', 'afterPlus')} children={i18n('addImgTextAfterAdd')} />
        </div>
      );
    }

    return (
      <div>
        <Input
          value={this.state.inputValue}
          schema={{ placeholder: i18n('addInputPlaceholder') }}
          onChange={inputValue => this.setState({ inputValue })}
          noError
        />
      </div>
    );
  }

  render() {
    const { i18n } = this;
    const { content, onCloseRequired, insertSrc } = this.props;

    return (
      <Modal
        {...classesModalEditor(null, content)}
        onCloseRequired={onCloseRequired}
        size={content === modalContentCfg.smiles ? 'medium' : 'small'}
        renderModal
      >
        <Header closeButton>
          {content === modalContentCfg.smiles ? i18n('modalHeaderTextSmile') : i18n('modalHeaderTextData')}
        </Header>
        <Content>
          {this.renderContent()}
        </Content>
        <Footer>
          <button close label={i18n('cancel')} theme={btnThemes.light} />
          <button
            onClick={() => insertSrc(
              this.state.inputValue ||
              this.state.imageValue ||
              null
            )}
            label={i18n('done')}
            theme={btnThemes.sky}
            close
          />
        </Footer>
      </Modal>
    );
  }
}
